<template lang="pug">
.container-requests
  .header
    h4 {{$t('Requests Failed')}}
    .section(v-if='alreadySeen')
      span {{ $t('From date: ') }}
      el-date-picker.picker(:picker-options="{ firstDayOfWeek: 1 }", id="FailedRequestsList-fromDatePicker" v-model="fromDate", type="date", :placeholder="$t('since log-in')")
    el-checkbox(id="FailedRequestsList-seenCheckbox" v-model='alreadySeen') {{ $t('display already seen') }}
  hr.header
  .section(v-if='fetchedRequests.length > 0')
    .row.header
      .cell.wide {{$t('Device')}}
      .cell.narrow {{$t('Sent time')}}
      .cell.narrow {{$t('Report time')}}
      .cell.narrow {{$t('Method')}}
      .cell.wide {{$t('Response')}}
    hr.header
    .row.request(v-for="(request, index) of fetchedRequests", :id="'FailedRequestsList-request'+request.id")
      .cell.wide {{getFullDeviceNameByDesktopId(request.DeviceDesktop)}}
      .cell.narrow {{humanTime(request.createdAt)}}
      .cell.narrow {{humanTime(request.updatedAt)}}
      .cell.narrow {{request.method}}
      .cell.wide {{request.responseRaw.name}} -
        span.warning &nbsp;{{request.responseRaw.message}}
  .section(v-else)
    span.success {{$t('No failed requests')}}
</template>

<script>
import Vue from 'vue'
import textUtils from '../Common/textUtils.mixin'

export default {
  mixins: [textUtils],
  created () {
    this.fetchedRequests = this.failedRequestsInSession()
    if (this.fetchedRequests.length === 0) this.alreadySeen = true
  },
  data () {
    return {
      requests: [],
      searchByName: '',
      alreadySeen: false,
      fetchedRequests: [],
      fromDate: ''
    }
  },
  watch: {
    fromDate: async function (newVal, oldVal) {
      this.fetchedRequests = await Vue.axios
        .post(`request/search`,
          {
            periodStart: new Date(newVal).getTime(),
            status: 'failed'
          }
        )
        .then(response => {
          return response.data
        })
    }
  },
  methods: {
    failedRequestsInSession () {
      if (!this.alreadySeen) {
        return this.$store.state.Request.requests_failed_list.filter(fr => !fr.seen)
      } else {
        return this.$store.state.Request.requests_failed_list
      }
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.row {
  display: flex;
  align-items: center;
  width: 100%;
  &.header {
    color: grey;
    margin-bottom: 10px;
  }
  &.request {
    border-bottom: $--border-light;
    padding: 10px 0px;
  }
  .cell {
    &.narrow {
     width: calc(40%/3);
    }
    &.wide {
      width: calc(60%/2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/FailedRequestsList.vue